import React, {useState, useEffect} from 'react';
import SpeedlyAnswer from './SpeedlyAnswer';
import livechat_icons from './liveChatFunction/livechat_icons';
import liveChatFunction from './liveChatFunction/liveChatFunction';
import setNewMessage from './liveChatRequest/liveChatSetNewMessage';
import setCommunicationIsClose
    from './liveChatRequest/liveChatSetCommunicationIsClose';
import getActiveCom from './liveChatRequest/liveChatGetActiveCom';

export default function NewMessageForm(props) {

    const [messageLength, setMessageLength] = useState(0);

    useEffect (() => {
        let scroll = document.querySelector('.display_communication');
        scroll.scrollTop=scroll.scrollHeight;

        return;
    })

    return (
        <ul
            key="hotline_newMessage"
            className="newMessageDiv"
            style={
                {
                    background: 'rgba(140, 140, 140, 0.8'
                }
            }>
            <li key="answer" className="comHeader">
                <span style={{color: 'black', fontSize: '14px'}}>
                    Répondez à {
                        props.state.current_communication.substring(
                            0,
                            props.state.current_communication.indexOf(' ('),
                            )}
                </span>
                <span
                    style={{
                        color: messageLength > 254 ? 'red' : 'black',
                        paddingLeft: '50px',
                    }}>
                    {messageLength + ' / 255'}
                </span>
                <button
                    style={{
                        '--newMesButBackground': '#F7D59E',
                        transform: 'scale(0.8)',
                        color: 'red',
                    }}
                    onClick={() => {
                            document.querySelector('#newMessageContent').value='';
                            setMessageLength(0);
                        }}>
                        {livechat_icons.reset_message()}
                </button>
                <button
                    style={{'--newMesButBackground': 'lightgreen'}}
                    onClick={() => liveChatFunction.sendNewMessage(
                            '',
                            props.state,
                            props.dispatch,
                            setNewMessage,
                            setMessageLength,
                            getActiveCom,
                        )}>
                    {livechat_icons.send_message()}
                </button>
                <SpeedlyAnswer
                    state={props.state}
                    dispatch={props.dispatch}
                    // setComList={props.setComList}
                    setNewMessage={setNewMessage}
                    setMessageLength={setMessageLength}
                    getActiveCom={getActiveCom}
                    pseudo={props.pseudo} />
            </li>
            <li>
                <textarea
                    rows="3"
                    id="newMessageContent"
                    style={{
                            width: '92%'
                        }}
                    onChange={() => {
                            setMessageLength(
                                document.querySelector('#newMessageContent').value.length
                            );
                            if (document.querySelector('#newMessageContent').value.length >= 255) {
                                document.querySelector('#newMessageContent').value =
                                    document.querySelector('#newMessageContent').value.substr(0, 254)
                            }
                        }}></textarea>
            </li>
            <li className="resolvedCom">
                <button
                    className="resolvedComBut"
                    onClick={
                        () => {
                            props.dispatch({
                                type: 'change_current_communication',
                                payload: {current_communication: ''}
                            });
                            setCommunicationIsClose(
                                props.state,
                                props.dispatch,
                            );
                    }}>
                    Conversation résolue ?
                </button>
            </li>
        </ul>
    )
}